<!-- Bulk Actions Bar -->
<div
  class="tw-fixed tw-bottom-5 md:!tw-left-[5%] tw-z-[5] tw-flex tw-justify-center tw-w-full tw-h-[56px]"
  id="batch-operations-container"
  [shown]="selectedCount > 0"
>
  <div
    class="tw-flex tw-items-center tw-gap-[10px] tw-py-2 tw-pl-4 tw-pr-2 tw-text-white tw-rounded-full tw-shadow-lg"
    [class.tw-bg-gray-800]="withinSelectionLimit"
    [class.tw-bg-red-600]="!withinSelectionLimit"
  >
    <span
      class="tw-flex tw-items-center tw-justify-center tw-w-[40px] tw-h-[40px] tw-px-2 tw-rounded-full tw-text-white tw-text-xl tw-font-semibold"
      [class.tw-bg-gray-600]="withinSelectionLimit"
      [class.tw-bg-red-800]="!withinSelectionLimit"
    >
      {{ selectedCount }}
    </span>
    <span [class]="messageClasses">{{ messageText }}</span>
    @if (withinSelectionLimit) {
      <button
        mat-flat-button
        class="!tw-bg-rise-green-700 hover:tw-bg-rise-green-600 !tw-text-white tw-font-medium tw-rounded-[6px] tw-px-4 tw-min-w-[120px] tw-min-h-[32px]"
        (click)="startSharing.emit()"
      >
        Start Sharing
      </button>
    }
    <button
      mat-icon-button
      aria-label="Clear selection"
      [class]="clearButtonClass"
      (click)="clearSelection.emit()"
    >
      <mat-icon svgIcon="close" class="tw-w-[18px] tw-h-[18px]" />
    </button>
  </div>
</div>
